import { OpenInNewOutlined } from '@mui/icons-material';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useEmailEditorDrawerHandler from './email-editor-drawer.hooks';

type TagErrorsProps = {
  error: ReturnType<typeof useEmailEditorDrawerHandler>['error'];
};

const TagErrors = ({ error }: TagErrorsProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      {error?.mergeTagErrors.map(tagError => (
        <Alert severity="error" key={tagError.name}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography>
              {t('drawer.emailEditorDrawer.error.requiredMergeTag.message', {
                name: tagError.name,
              })}
            </Typography>
            <Link href="#mergeTagPlaceholder">
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <OpenInNewOutlined fontSize="inherit" />
                <Typography>
                  {t(
                    'drawer.emailEditorDrawer.error.requiredMergeTag.whatsThis',
                  )}
                </Typography>
              </Stack>
            </Link>
          </Stack>
        </Alert>
      ))}
      {error?.specialLinkErrors.map(tagError => (
        <Alert severity="error" key={tagError.name}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography>
              {t('drawer.emailEditorDrawer.error.requiredSpecialLink.message', {
                name: tagError.name,
              })}
            </Typography>
            <Link href="#specialLinkPlaceholder">
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <OpenInNewOutlined fontSize="inherit" />
                <Typography>
                  {t(
                    'drawer.emailEditorDrawer.error.requiredSpecialLink.whatsThis',
                  )}
                </Typography>
              </Stack>
            </Link>
          </Stack>
        </Alert>
      ))}
      {error?.imageErrors && (
        <Alert severity="error">
          {t('drawer.emailEditorDrawer.error.images.message')}
        </Alert>
      )}
    </Stack>
  );
};

export default TagErrors;
